import {
  IBoltTaskSLA,
  IBoltTaskSOP,
  INewBoltTaskRule,
  SLAUnits,
} from "@bolt/core";
import {
  EnumRadioFieldProps,
  FieldSchemaFormBuilderV2,
  SchemaFactoryV2,
  ComplexFieldProps,
  fieldTypes,
  AsyncODataDropdownFieldProps,
} from "@ucl/library";
import {
  QueryBuilder,
  QueryBuilderProps,
} from "../../QueryBuilder/QueryBuilder";
import {
  RecurrenceEditorField,
  RecurrenceEditorFieldProps,
} from "../../RecurrenceEditorField/RecurrenceEditorField";
import { SLAComponent } from "../../SlaComponent/SlaComponent";
import { SOPComponent } from "../../SOPComponent/SOPComponent";
import {
  TaskTypeAsyncAutoCompleteProps,
  taskTypeAsyncAutoCompleteConfig,
} from "../../config/taskTypeAsyncAutoComplete";
import { isNil } from "lodash";

export const editBoltTaskRuleBuilder: (
  factory: SchemaFactoryV2,
  options: {
    taskTypeProps: TaskTypeAsyncAutoCompleteProps;
    taskRuleTypeProps: EnumRadioFieldProps;
    eventConditionProps: Partial<QueryBuilderProps> & {
      apiBaseUrl: string;
      getAuthRequestHeader: () => Promise<Record<string, string> | undefined>;
    };
    timeConditionProps: Partial<RecurrenceEditorFieldProps>;
  }
) => FieldSchemaFormBuilderV2<INewBoltTaskRule> =
  (factory, { taskTypeProps, eventConditionProps }) =>
  (onValueChange, form, errors) => {
    return [
      ...factory.buildFieldSchemas<INewBoltTaskRule>(
        "BoltTaskRule",
        [
          "BoltTaskRule__TaskRuleName",
          {
            ...taskTypeAsyncAutoCompleteConfig(taskTypeProps),
            fieldKey: "BoltTaskRule__TaskTemplateId",
            onSubmit: function (boltTaskTemplate) {
              onValueChange(
                {
                  ...form,
                  taskTemplateId: boltTaskTemplate?.id || "",
                  taskTemplateEntityType: boltTaskTemplate?.entityType,
                  taskTemplateDescription:
                    boltTaskTemplate?.taskTemplateDescription,
                  taskTemplateSOP: boltTaskTemplate?.taskTemplateSOP,
                  taskTemplateSOP_AsList:
                    boltTaskTemplate?.taskTemplateSOP_AsList,
                  taskTemplateSLA: boltTaskTemplate?.sla ?? 0,
                  taskTemplateSLAUnit:
                    boltTaskTemplate?.slaUnit ?? SLAUnits.Day,
                },
                boltTaskTemplate?.id || "",
                this as fieldTypes.BaseFieldProps<fieldTypes.CoreFieldValue>
              );
            },
          },
          {
            fieldKey: "BoltTaskRule__TaskRuleEventTypeName",
            baseODataUrl: `${eventConditionProps.apiBaseUrl}/odata`,
            suffixODataUrl: `?$filter=(entityType eq '${form.taskTemplateEntityType}' or entityType eq null)`,
            hidden: isNil(form.taskTemplateEntityType),
          } as AsyncODataDropdownFieldProps,
          {
            fieldKey: "BoltTaskRule__TaskTemplateDescription",
            readOnly: true,
            disabled: true,
          },
          {
            fieldKey: "BoltTaskRule__SOP_AsObject",
            fieldName: "BoltTaskRule__SOP_AsObject",
            label: "",
            type: "Complex",
            value: {
              sop: form.taskTemplateSOP,
              sop_AsList: form.taskTemplateSOP_AsList,
            },
            readOnly: true,
            disabled: true,
            renderer: SOPComponent,
          } as ComplexFieldProps<IBoltTaskSOP>,
          {
            type: "Complex",
            fieldKey: "BoltTaskRule__SLA_AsObject",
            fieldName: "BoltTaskRule__SLA_AsObject",
            value: {
              sla: form.taskTemplateSLA,
              slaUnit: form.taskTemplateSLAUnit,
            },
            readOnly: true,
            disabled: true,
            availableSLAUnits: [SLAUnits.Day, SLAUnits.Hour],
          } as unknown as ComplexFieldProps<IBoltTaskSLA>,
          // {
          //   fieldKey: "BoltTaskRule__TaskRuleType",
          //   optionValues: taskRuleTypeProps.optionValues,
          //   readOnly: true,
          //   disabled: true,
          // } as EnumRadioFieldProps,
          // {
          //   ...timeConditionProps,
          //   fieldKey: "BoltTaskRule__TimeCondition",
          //   onSubmit: function (timeCondition) {
          //     onValueChange(
          //       { ...form, timeCondition },
          //       timeCondition,
          //       this as fieldTypes.BaseFieldProps<fieldTypes.CoreFieldValue>
          //     );
          //   },
          //   hidden: form.taskRuleType != BoltTaskRuleTypes.Time,
          // },
          // {
          //   ...eventConditionProps,
          //   fieldKey: "BoltTaskRule__EventCondition",
          //   hidden: form.taskRuleType != BoltTaskRuleTypes.Event,
          //   canHaveDuplicateStatusesField: {
          //     data: form.canHaveDuplicateStatuses,
          //     setter: function (canHaveDuplicateStatuses) {
          //       onValueChange(
          //         { ...form, canHaveDuplicateStatuses },
          //         canHaveDuplicateStatuses,
          //         this as fieldTypes.BaseFieldProps<fieldTypes.CoreFieldValue>
          //       );
          //     },
          //   },
          // } as QueryBuilderProps,
          "BoltTaskRule__IsActive",
          "BoltTaskRule__IsUnique",
        ],
        onValueChange,
        form,
        errors,
        [
          "BoltTaskRule__TaskRuleName",
          "BoltTaskRule__TaskTemplateId",
          "BoltTaskRule__TaskRuleType",
        ],
        {
          BoltTaskSOP: SOPComponent,
          BoltTaskSLA: SLAComponent,
          TimeBase: RecurrenceEditorField,
          EventBase: QueryBuilder,
        }
      ),
    ];
  };

// export const createBoltTaskRuleBuilder: (
//   apiBaseUrl: string,
//   getAuthRequestHeader: () => Promise<Record<string, string> | undefined>
// ) => FieldSchemaFormBuilderV2<INewBoltTaskRule> =
//   (apiBaseUrl, getAuthRequestHeader) => (onValueChange, form, errors) => {
//     return [
//       {
//         type: "Text",
//         fieldName: "boltTaskRuleName",
//         fieldKey: "boltTaskRuleName",
//         label: "Task Rule Name",
//         placeholder: "Type here...",
//         isRequired: true,
//         value: form.boltTaskRuleName,
//         disableToolTip: true,
//         onSubmit: function (boltTaskRuleName) {
//           onValueChange(
//             { ...form, boltTaskRuleName: boltTaskRuleName || "" },
//             boltTaskRuleName || "",
//             this
//           );
//         },
//       } as TextFieldProps,
//       {
//         type: "Text",
//         fieldName: "boltTaskRuleName",
//         fieldKey: "boltTaskRuleName",
//         label: "Task Rule Name",
//         placeholder: "Type here...",
//         isRequired: true,
//         value: form.boltTaskRuleName,
//         disableToolTip: true,
//         onSubmit: function (boltTaskRuleName) {
//           onValueChange(
//             { ...form, boltTaskRuleName: boltTaskRuleName || "" },
//             boltTaskRuleName || "",
//             this
//           );
//         },
//       } as TextFieldProps,
//       taskTypeAsyncAutoCompleteProps(
//         apiBaseUrl,
//         form.boltTaskTypeId,
//         getAuthRequestHeader,
//         function (boltTaskType, props) {
//           onValueChange(
//             {
//               ...form,
//               boltTaskTypeId: boltTaskType?.id || "",
//               boltTaskTypeDescription: boltTaskType.shortDescription,
//               boltTaskTypeSOP: boltTaskType.boltTaskTypeSOP,
//               boltTaskTypeSOP_AsList: boltTaskType.boltTaskTypeSOP_AsList,
//               boltTaskTypeSLA: boltTaskType.sla ?? 0,
//               boltTaskTypeSLAUnit: boltTaskType.slaUnit ?? SLAUnits.Days,
//             },
//             boltTaskType?.id || "",
//             props
//           );
//         },
//         false
//       ),
//       {
//         type: "TextArea",
//         fieldName: "boltTaskTypeDescription",
//         fieldKey: "boltTaskTypeDescription",
//         label: "Task Type Description",
//         placeholder: "Type here...",
//         readOnly: true,
//         value: form.boltTaskTypeDescription,
//       } as TextAreaFieldProps,
//       {
//         type: "TextArea",
//         fieldName: "boltTaskTypeDescription",
//         fieldKey: "boltTaskTypeDescription",
//         label: "Task Type Description",
//         placeholder: "Type here...",
//         readOnly: true,
//         value: form.boltTaskTypeDescription,
//       } as TextAreaFieldProps,
//       {
//         type: "Complex",
//         fieldName: "boltTaskTypeSOP_AsList",
//         fieldKey: "boltTaskTypeSOP_AsList",
//         label: "SOP",
//         value: form.boltTaskTypeSOP_AsList,
//         renderer: SOPComponent,
//       } as ComplexFieldProps,
//       {
//         type: "Complex",
//         fieldName: "boltTaskTypeSOP_AsList",
//         fieldKey: "boltTaskTypeSOP_AsList",
//         label: "SOP",
//         value: form.boltTaskTypeSOP_AsList,
//         renderer: SOPComponent,
//       } as ComplexFieldProps,
//       // Task Type
//       // {} as AsyncAutoCompleteFieldProps,
//       // Task Type Description
//       // {} as TextFieldProps,
//       // Task Type Stepname
//       // {} as TextFieldProps,
//       // Assignee
//       // {} as AsyncAutoCompleteFieldProps,
//     ];
//   };
